<template>
  <el-dialog title="Prorrogar Aluguel" :visible.sync="visibility" @open="iniciar" :before-close="fechar" :close-on-click-modal="false" append-to-body v-loading="isLoading" width="400px">
    <el-form ref="form" size="small" label-position="top" hide-required-asterisk	:show-message="false" style="padding:0;">

      <el-row :gutter="10">
        <el-col :span="12">
          <el-form-item>
            <template slot="label">
            <strong style="font-size: 15px">Prorrogar por</strong>
            </template>
            <el-input v-model="mesesProrrogacao" v-mask="'###'">
              <template slot="append">meses</template>
            </el-input>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="10">
        <el-col :span="24">
          <el-form-item>
            <template slot="label">
            <strong style="font-size: 15px">Valor Atual</strong>
            </template>
            <div class="el-input el-input--small">
              <money
                v-model="aluguel.valor"
                v-bind="money"
                readonly
                class="el-input__inner"
              />
            </div>
          </el-form-item>
        </el-col>
      </el-row>

      <el-row :gutter="20">
        <el-col>
          <el-form-item>
            <template slot="label">
            <strong style="font-size: 15px">Novo Valor</strong>
            </template>
            <el-switch
              v-model="percentualProrrogacaoIsSelecionado"
              inactive-text="Valor"
              active-text="Percentual"
              active-color="#008080"
              inactive-color="#008080"
            />
          </el-form-item>
        </el-col>
      </el-row>

      <el-row v-if="percentualProrrogacaoIsSelecionado" :gutter="20">
        <el-col :span="12">
          <el-form-item prop="comissao">
            <el-input
              v-model="percentualReajuste"
              @input="calcularNovoValor"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="append">
                {{ percentualProrrogacaoIsSelecionado ? "%" : "" }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-tag style="font-size: 14px">
            {{ this.formatarValor(novoValor) }}
          </el-tag>
        </el-col>
      </el-row>

      <el-row v-else :gutter="20">
        <el-col :span="12">
          <el-form-item prop="comissao">
            <el-input
              v-model="novoValor"
              @input="calcularPercentual"
              @keypress.native="validarInputNumerico"
              @keyup.native="validarSeparadorDecimal"
            >
              <template slot="prepend">
                {{ !percentualProrrogacaoIsSelecionado ? "R$" : "" }}
              </template>
            </el-input>
          </el-form-item>
        </el-col>

        <el-col :span="12">
          <el-tag style="font-size: 14px">
            {{ this.formatarPercentual(percentualReajuste) }}
          </el-tag>
        </el-col>
      </el-row>

    </el-form>
    <span slot="footer">
      <el-button @click="confirmarProrrogarHandler" type="primary" size="small" round class="btn-box-shadow">Concluir</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { mapActions, mapState } from "vuex";
import Util from "../../../util/funcoes.js";
import { Money } from "v-money";

export default {
  components:{
    Money
  },
  props: {
    aluguel: Object,
    visibility: Boolean
  },
  data() {
    return {
      novoValor: 0,
      percentualReajuste: 0,
      mesesProrrogacao: undefined,

      percentualProrrogacaoIsSelecionado: false,

      money: {
        decimal: ",",
        thousands: ".",
        precision: 2,
        masked: false
      },

      percent: {
        decimal: ",",
        thousands: ".",
        suffix: " %",
        precision: 2,
        masked: false
      }
    }
  },
  computed: {
    ...mapState({
      isLoading(state) { return state.loading },
    }),

    util() {
      return Util;
    }
  },
  methods: {
    ...mapActions(["showLoading", "hideLoading"]),
    ...mapActions("alugueisContratosStore",["prorrogarAluguel"]),

    iniciar() {
      this.reset();
      this.calcularNovoValor();
    },

    confirmarProrrogarHandler() {
      this.$confirm("Após a efetivação da prorrogação, novos recibos serão criados conforme a quantidade de meses informada. A duração do contrato e os meses para reajuste não serão alterados. Você tem certeza que deseja confirmar a prorrogação do contrato?", "Atenção", {
        confirmButtonText: "Sim",
        cancelButtonText: "Não",
        type: "warning"
      }).then(() => {
        this.prorrogar();
        });
		},

    prorrogar(){
      if(!this.mesesProrrogacao || this.mesesProrrogacao <= 0){
        this.$message.info("Informe a duração da Prorrogação");
        return
      }

      if(!this.novoValor || parseFloat(this.novoValor) <= 0){
        this.$message.info("Informe um valor acima de R$ 0,00 no campo de Novo Valor.");
        return
      }

      let payload;

      payload = { 
        id: this.aluguel.id,
        valor: this.novoValor,
        duracao: this.mesesProrrogacao
      }

      this.showLoading();
      this.prorrogarAluguel(payload)
        .then(resultado => {
          this.hideLoading();
          switch (resultado.status) {
            case "SUCESSO":
              this.$message.success(resultado.mensagem);
              this.fechar()
              break;
            default:
              this.$message.error(resultado.mensagem);
          }
        })
        .catch(() => {
          this.$message.error("Ocorreu um erro.");
          this.hideLoading();
        });
    },

    calcularNovoValor() {
      const valor = (this.aluguel.valor + (this.aluguel.valor * (this.percentualReajuste/100))).toFixed(2);

      if(isFinite(valor)) {
        this.novoValor = valor;
      } else {
        this.novoValor = 0;
      }
    },

    calcularPercentual() {
      this.percentualReajuste = (((this.novoValor - this.aluguel.valor) * 100)/this.aluguel.valor).toFixed(2);
        
      if(isNaN(this.percentualReajuste)) {
        this.percentualReajuste = 0;
      } 
    },

    formatarValor(valor) {
      return isFinite(valor)
        ? Util.formatarValor(valor)
        : Util.formatarValor(0);
    },
    formatarPercentual(percentual) {
      return isFinite(percentual)
        ? Util.formatarPercentual(percentual)
        : Util.formatarPercentual(0);
    },

    validarSeparadorDecimal(event) {
      const textoDigitado = event.target.value;
      
      const textoComVirgulasTratadas = this.substituirTodaVirgulaPorPonto(textoDigitado);
      const textoComPontosTratados = this.removerTodosOsPontosDepoisDoPrimeiro(textoComVirgulasTratadas);

      const textoFinal = textoComPontosTratados;

      event.target.value = textoFinal;
    },

    validarInputNumerico(event) {
      const valorDigitado = event.key;
      const valoresPermitidos = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9', '.', ','];
      const valorNaoEhPermitido = !valoresPermitidos.includes(valorDigitado);

      if(valorNaoEhPermitido) event.preventDefault();
    },

    substituirTodaVirgulaPorPonto(texto) {
      return texto.replace(/,/g, '.');
    },
    removerTodosOsPontosDepoisDoPrimeiro(texto) {
      return texto.replace(/(?<=\..*)\./g, '');
    },

    reset() {
      this.novoValor = 0;
      this.percentualReajuste = 0;
      this.mesesProrrogacao = undefined;
      this.percentualProrrogacaoIsSelecionado = false;
    },

    fechar() {
      this.$emit('close');
    }, 
  }
}
</script>
